import moment from 'moment'

export const todaysDate = (format = 'YYYY-MM-DD') => moment().format(format)

export const tomorrowsDate = (format = 'YYYY-MM-DD') =>
  moment()
    .add(1, 'days')
    .format(format)

export const formatDate = (ms, dateFormat = 'MM/DD/YYYY') => (ms ? moment(ms).format(dateFormat) : '')

// Shared methods for Flights, SOPQ Flights and RC
export const getDateRange = (
  { departureDate, arrivalDate },
  isOneWay,
  format = formatDate
) => {
  if (!departureDate) return ''
  const start = format(departureDate)
  if (isOneWay) return start
  const end = format(arrivalDate)
  return `${start} – ${end}`
}

export const getHotelDateRange = ({ startDate, endDate }) => {
  if (!startDate && !endDate) return ''
  const start = formatDate(startDate)
  const end = formatDate(endDate)
  return [start, end].join(' – ')
}

export const getPackagesDateRange = ({ startDate, endDate }) => {
  if (!startDate) return ''
  return formatDate(startDate) + ' - ' + formatDate(endDate)
}

export const getMaxDate = ({ endDate, maxDays, dateFormat = 'YYYYMMDD' }) => {
  return endDate
    ? moment(endDate, dateFormat)
      .format(dateFormat)
    : moment()
      .add(maxDays, 'days')
      .format(dateFormat)
}

export const getMinDate = ({ startDate, dateFormat = 'YYYYMMDD' }) => {
  return startDate
    ? moment(startDate, dateFormat)
      .format(dateFormat)
    : moment()
      .format(dateFormat)
}
